import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const wellApi = createApi({
    reducerPath: "core/well",
    baseQuery: axiosBaseQuery,
    tagTypes: ["wellList"],
    endpoints: (builder) => ({
        wellFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['wellList'],
            query: (query = '') => ({
                url: "/core/well" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        wellCreate: builder.mutation({
            invalidatesTags: ['wellList'],
            query: (data) => ({
                url: `/core/well`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        wellUpdate: builder.mutation({
            invalidatesTags: ['wellList'],
            query: (data) => ({
                url: `/core/well/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            })
        }),

        wellDelete: builder.mutation({
            invalidatesTags: ['wellList'],
            query: (id) => ({ url: "/core/well/" + id, method: "DELETE" })
        }),
    })
})

export const { useWellFindAllQuery, useWellCreateMutation, useWellUpdateMutation, useWellDeleteMutation } = wellApi;
export { wellApi };
